var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYouTubeHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 16C31.5 24.5604 24.5604 31.5 16 31.5C7.43959 31.5 0.5 24.5604 0.5 16C0.5 7.43959 7.43959 0.5 16 0.5C24.5604 0.5 31.5 7.43959 31.5 16Z",
    stroke: "#002C43"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4832 9.55298C12.3359 9.40604 14.5224 9.33325 16.19 9.33325C17.8575 9.33325 20.0069 9.40604 21.8967 9.55298C24.0832 9.73597 25.1954 10.1026 25.4913 12.2632C25.64 13.2523 25.7136 14.6081 25.7136 15.9999C25.7136 17.3918 25.64 18.7836 25.4913 19.736C25.1954 21.9339 24.0832 22.2632 21.8967 22.4469C20.0069 22.6299 17.8575 22.6666 16.19 22.6666C14.5224 22.6666 12.3359 22.6299 10.4832 22.4469C8.29673 22.2632 7.14809 21.9339 6.85146 19.736C6.72281 18.4947 6.66102 17.2476 6.66633 15.9999C6.66202 14.752 6.72381 13.5047 6.85146 12.2632C7.14809 10.1026 8.29673 9.73597 10.4832 9.55298Z",
    fill: "#002C43"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2852 13.1428L18.7296 15.9815L14.2852 18.8571V13.1428Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTubeHover);
export default __webpack_public_path__ + "static/media/YouTube-hover.b64c41e87861a0a8f979f0952feec54f.svg";
export { ForwardRef as ReactComponent };